import React, { useState } from 'react'
import { FaVolumeOff, FaVolumeUp } from 'react-icons/fa'
import MatchingGame from './MatchingGame'
import MemoryCardGame from './MemoryCardGame'
import CardMatchingGame from './CardMatchingGame'
import MatchingPairGame2 from './MatchingPairGame2'

interface ExercisesProps {
  topic: {
    exercises: {
      question: string
      options: string[]
      correctAnswer: string
    }[]
    examplesImages?: { image: string; description: string }[]
    matchPair?: {
      pairs: { left: string; right: string }[]
    }
    additionalMatchPair?: {
      pairs: { left: string; right: string }[]
    }
  }
  currentExampleIndex: number
  isSpeaking: boolean
  speakExplanation: any
  handleNextExample: () => void
}

const Exercises: React.FC<ExercisesProps> = ({
  topic,
  currentExampleIndex,
  isSpeaking,
  speakExplanation,
  handleNextExample
}) => {
  const currentExercise = topic?.exercises?.[currentExampleIndex]
  const [currentGameIndex, setCurrentGameIndex] = useState<number>(0)

  const games = [
    (props: any) => (
      <div className='row'>
        <div className='d-flex justify-content-start mt-5'>
          <h1 className='mt-4 text-danger'>निम्नलिखित का मिलान करें</h1>
        </div>
        <div className='d-flex justify-content-center mt-5'>
          <CardMatchingGame {...props} pairs={topic?.matchPair?.pairs || []} />
        </div>
      </div>
    ),
    (props: any) => (
      <div className='row'>
        <div className='d-flex justify-content-start mt-5'>
          <h1 className='mt-4 text-danger'>निम्नलिखित का मिलान करें</h1>
        </div>
        <div className='d-flex justify-content-center mt-5'>
          <MatchingPairGame2 {...props} pairs={topic?.additionalMatchPair?.pairs || []} />
        </div>
      </div>
    ),
    (props: any) => (
      <MemoryCardGame
        {...props}
        options={currentExercise?.options}
        answer={currentExercise?.correctAnswer}
      />
    ),
    (props: any) => (
      <MatchingGame
        {...props}
        options={currentExercise?.options}
        answer={currentExercise?.correctAnswer}
      />
    )
  ]

  const renderGame = () => {
    const GameComponent = games[currentGameIndex % games.length]
    return (
      <GameComponent
        key={`game-${currentGameIndex}`}
        handleNextExample={() => {
          setCurrentGameIndex((prevIndex) => prevIndex + 1)
          handleNextExample()
        }}
      />
    )
  }

  if (!currentExercise) {
    return <p className='text-danger'>व्यायाम डेटा उपलब्ध नहीं है।</p>
  }

  const renderExampleImages = () => {
    if (topic?.examplesImages?.length) {
      return (
        <div className='d-flex flex-wrap justify-content-start mt-3'>
          {topic?.examplesImages?.map((example, index) => (
            <div key={index} className='m-2 text-center'>
              <img
                src={example?.image}
                alt={example?.description}
                className='img-thumbnail'
                style={{ width: '500px', height: '500px', objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>
      )
    }
    return null
  }

  if (currentGameIndex % games.length < 2) {
    return (
      <div className='card shadow-lg rounded-lg p-4 mb-4'>
        {/* Header Section */}
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <h1 className='text-info font-weight-bold'>आइए, प्रश्नोत्तरी शुरू करें</h1>
          <button
            className='btn bg-transparent border-0 ms-3 d-flex align-items-center justify-content-center'
            onClick={() => speakExplanation(currentExercise?.question)}
            style={{ fontSize: '1.5rem', cursor: 'pointer' }}
          >
            {isSpeaking ? (
              <FaVolumeUp className='text-dark' style={{ transform: 'scale(1.2)' }} />
            ) : (
              <FaVolumeOff className='text-secondary' style={{ transform: 'scale(1.2)' }} />
            )}
          </button>
        </div>

        {renderExampleImages()}

        {renderGame()}
      </div>
    )
  }

  return (
    <div className='card shadow-lg rounded-lg p-4 mb-4'>
      {/* Header Section */}
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h1 className='text-info font-weight-bold'>आइए, प्रश्नोत्तरी शुरू करें</h1>
        <button
          className='btn bg-transparent border-0 ms-3 d-flex align-items-center justify-content-center'
          onClick={() => speakExplanation(currentExercise?.question)}
          style={{ fontSize: '1.5rem', cursor: 'pointer' }}
        >
          {isSpeaking ? (
            <FaVolumeUp className='text-dark' style={{ transform: 'scale(1.2)' }} />
          ) : (
            <FaVolumeOff className='text-secondary' style={{ transform: 'scale(1.2)' }} />
          )}
        </button>
      </div>

      {/* Display Example Images */}
      {renderExampleImages()}

      {/* Question and Options Section */}
      <h1 className='mt-4 text-success'>{`प्रश्न ${currentExampleIndex + 1}`}</h1>
      <p className='font-weight-bold' style={{ fontSize: '1.8rem' }}>
        {currentExercise?.question}
      </p>

      {/* Options */}
      <div className='d-flex justify-content-start mt-5'>
        {currentExercise?.options?.length > 0 && (
          <div className='d-flex flex-row flex-wrap'>
            {currentExercise?.options?.map((link, index) => (
              <img
                key={index}
                src={link}
                alt={`Option ${index + 1}`}
                className='img-thumbnail m-2'
                style={{ width: '150px', height: '150px', objectFit: 'cover' }}
              />
            ))}
          </div>
        )}
      </div>

      {/* Fixed Game Sequence */}
      <div className='row'>
        <div className='d-flex justify-content-start mt-5'>
          <h1 className='mt-4 text-warning fw-bolder'>खेल</h1>
        </div>
        <div className='d-flex justify-content-center mt-5'>{renderGame()}</div>
      </div>
    </div>
  )
}

export default Exercises
